import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { Loader } from '../components';
import { Table } from '../components/table/table';
import { runInAction } from 'mobx';
import { StudioPageProps } from '../hooks';
import { WithLoadingState } from '../router';
import { tableStore } from '../stores/table-store';
import { useProStudioCtxSelector } from '../xstate/app.xstate';
import { Stack } from '@pypestream/design-system';

type BuilderPageProps = StudioPageProps;

const BuilderPage: React.FC<BuilderPageProps> = observer(() => {
  const {
    botName,
    draftVersion,
    customerId,
    botId,
    projectId,
    projectName,
    selectedBotName,
  } = useProStudioCtxSelector((ctx) => ({
    botName: ctx.botName,
    customerId: ctx.customerId,
    projectId: ctx.project?.projectProStudioSetting?.id,
    botId:
      ctx.customerId && ctx.botName
        ? `${ctx.customerId}.${ctx.botName}`
        : undefined,
    deployedVersions: ctx.deployedVersions,
    draftVersion: ctx.draftVersion,
    projectName: ctx.project?.name,
    selectedBotName: ctx.selectedBot?.displayName,
  }));

  const solutionVersionId = `${customerId}-${botName}-${draftVersion}`;

  useEffect(() => {
    if (
      customerId &&
      botName &&
      draftVersion !== '' &&
      draftVersion !== undefined &&
      draftVersion !== null &&
      projectId !== null &&
      projectId !== '' &&
      botId
    ) {
      runInAction(() => {
        tableStore.botId = botId;
        tableStore.solutionVersionId = solutionVersionId;
        if (projectId) {
          tableStore.projectProStudioSettingId = projectId;
        }
        tableStore.draftVersion = draftVersion;
      });
    }
  }, [solutionVersionId, customerId, botName, draftVersion, botId, projectId]);

  useEffect(() => {
    return () => {
      runInAction(() => {
        tableStore.cleanupSolutionVersionSubscription(false);
      });
    };
  }, []); // Empty deps - only cleanup on unmount

  const isLoading = tableStore.currentState === 'loading';

  return (
    (isLoading && (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}
      >
        <Stack
          direction="column"
          gutter="medium"
          alignItems="center"
          style={{ textAlign: 'center' }}
        >
          <Loader relative />
        </Stack>
      </div>
    )) || <Table projectName={projectName} botName={selectedBotName} />
  );
});

export const Builder = WithLoadingState(BuilderPage);
